import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import UserContext from "../Context/UserContext"
import { signInWithMail } from "../Requests/firebaseAuth"
import {HiOutlineUserCircle} from 'react-icons/hi'
import './Styles/SignInPage.css'
import { RiErrorWarningLine } from "react-icons/ri"
import { getExhibitorsDocWhereEmail } from "../Requests/firebaseFirestore"
import { useTranslation } from "react-i18next"

export default function SignInPage(){
  const {t} = useTranslation()
  const {user} = useContext(UserContext)
  const navigate = useNavigate()
  const [errorMessage, setErrorMessage] = useState(null)
  const [loading, setLoading] = useState(false)
  
  
  useEffect(()=>{
    document.body.className = document.body.className = 'bg-image'
  })

  useEffect(()=>{
    if(user!=='checking'&&user!==false){
      navigate('/home')
    }
  },[user, navigate])


 const initialValue = {
   email:'',
   password: '',   
  }


  const [userInput, setUserInput] = useState(initialValue)
  
  const handleSubmit = async (e)=>{
    e.preventDefault();
    setLoading(true)
    
      const res = await signInWithMail(userInput)
      if(res.status==='success'){
        navigate('/home')
      }else{
        switch(res.error.code){
          case 'auth/wrong-password':
            setErrorMessage(t('wrongPassword'))
            break;
          case 'auth/user-not-found':
            setErrorMessage(t('userNotFound'))
            break;
          case 'auth/invalid-email':
            setErrorMessage(t('unvalidEmail'))
            break;
            default:
              break;
        }
      }
    setUserInput({...initialValue})
    setLoading(false)
  }
  
  const handleInputChange = (e) =>{
    setErrorMessage(null)
    const {name, value} = e.target
    setUserInput({...userInput, [name]: value})
  }
  
  return(
    <>
    <div className="container mx-auto pt-5 flex flex-col">
    <div className="w-full sm:w-96 mx-auto sm:mx-0 mb-4">
      <img alt="Channel Talks logo" src={require('../Assets/channeltalks-white.png')}/>
      <img alt="Channel Talks logo" src={require('../Assets/slogan-white.png')}/>
      </div>
      <div className="signin-holder flex flex-col mx-auto mt-5">
        <div className="flex flex-col text-center text-white my-4">
        <HiOutlineUserCircle size={100} className='mx-auto'/>
        <h1 className="font-semibold text-xl">{t('signIn')}</h1>
        </div>
        <form onSubmit={handleSubmit} className='flex flex-col gap-4'>
        <div className="input-holder w-[300px]">
          <input type="email" name='email' id="user-email" onChange={handleInputChange} value={userInput.email} required/>
          <label htmlFor="user-email">{t('email')}</label>
        </div>
        <div className="input-holder w-[300px]">
          <input type="password" name="password" id="user-password" onChange={handleInputChange} value={userInput.password} required/>
          <label htmlFor="user-password">{t('password')}</label>
          <div className="flex justify-end">
            <button className="text-white hover:underline mt-2 flex" onClick={()=>{navigate('/forgotpassword')}} type='button'>{t('forgotPassword')}.</button>
          </div>
        </div>
        {errorMessage?
        <span className="text-center text-white flex gap-1 border rounded-[10px] px-3 py-2 self-center"><RiErrorWarningLine size={25}/>{errorMessage}</span>
      :<></>}
          <button className="light-button w-fit mx-auto font-bold" disabled={loading}>{loading?t('loading')+'...':t('signIn')}</button>
        </form>
      </div>
    </div>
    </>
  )

}